module.exports = __webpack_public_path__ + "static/img/4areaA_1.16b1ca0.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/4areaA_1.png
// module id = 905
// module chunks = 1